import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'educationPipe'
})
export class EducationPipePipe implements PipeTransform {

  transform(value: any): string {


    if (!value)
      return '';

    const arrEducation: Array<any> = (function (raw) {
      try { return JSON.parse(raw); }
      catch (err) { return []; }
    })(value);

    if (arrEducation.length === 0)
      return '';

    return arrEducation.map(x => {

      return x?.educationProgram

    }).join("/ ");

  }
}
